const publicKeyUrl = `${window.CONFIG.baseURL}/gw/generic/getRSAPublicKey`;

export function aksEncode(params) {
  var obj = {
    publicKeyUrl,
    handleType: true,
    handleString: JSON.stringify(params)
  };
  return new Promise((resolve, reject) => {
    window.aksCommonHandle(obj, (res) => {
      if (!res.finally) {
        reject('加密失败');
      }
      
      resolve({
        channelEncrypt: 1,
        bodyEncrypt: res.processedStr.replace(/\+/g, "%2B")
      });
    });
  });
}

export function aksDecode(data) {
  var obj = {
    publicKeyUrl,
    handleType: false,
    handleString: data.resultData
  };
  return new Promise((resolve, reject) => {
    window.aksCommonHandle(obj, (res) => {
      if (!res.finally) {
        reject('解密失败');
      }
      
      resolve(
        Object.assign(
          {}, 
          data, 
          {
            resultData: JSON.parse(res.processedStr)
          }
        )
      );
    });
  });
}